import { Box, Input, InputGroup, InputLeftAddon, Tooltip } from '@chakra-ui/react';
import { FC } from 'react';
import { Field, useFormikContext } from 'formik';
import { SmallHeading } from 'src/components/common/texts/SmallHeading/smallHeading';
import { TooltipIcon } from 'src/utils/icons/tooltip';
import { ErrorLabel } from './ErrorLabel/errorLabel';

interface Props {
	label?: string | null;
	placeholder: string;
	leftText?: string | null;
	name: string;
	tooltip?: string | null;
	warningText?: string;
	fixedLeftWidth?: boolean;
	disabled?: boolean;
}

export const InputField: FC<Props> = ({
	label = null,
	fixedLeftWidth = false,
	placeholder,
	warningText = '',
	leftText = null,
	name,
	tooltip = null,
	disabled = false,
}) => {
	const { handleBlur } = useFormikContext();

	return (
		<Box
			marginTop={label ? '18px' : '12px'}
			position="relative"
		>
			{label && (
				<SmallHeading
					warningText={warningText}
					text={label}
				/>
			)}
			{tooltip && (
				<Tooltip
					color="#eee"
					padding="6px 10px"
					bg="black"
					borderRadius="4px"
					border="1px solid gray"
					label={tooltip}
				>
					<TooltipIcon
						cursor="pointer"
						position="absolute"
						top="4px"
						right="0"
					/>
					2
				</Tooltip>
			)}
			<InputGroup
				border="1px solid"
				borderColor="field.border"
				role="group"
				marginTop="7px"
				borderRadius="6px"
			>
				{leftText && (
					<InputLeftAddon
						bg="#272727"
						width={fixedLeftWidth ? '120px' : 'auto'}
						fontSize="14px"
						color="#686868"
					>
						{leftText}
					</InputLeftAddon>
				)}
				<Input
					onBlur={handleBlur}
					disabled={disabled}
					as={Field}
					color={disabled ? '#c5c5c5' : 'inherit'}
					name={name}
					placeholder={placeholder}
				/>
			</InputGroup>
			<ErrorLabel name={name} />
		</Box>
	);
};
